<script>
import HeaderElement from "@/components/article/HeaderElement.vue";
import ImageButton from "@/components/article/ImageButton.vue";
import lang from "@/directives/lang";

export default {
  name: "ArticleContentHeader",
  directives: {
    lang
  },
  components: {
    HeaderElement,
    ImageButton
  },
  props: {
    article: {
      type: Object,
      required: true
    },
    baseMeaning: {
      type: String,
      default: null
    },
    activeIllustrationUrl: {
      type: String,
      default: ""
    }
  },
  emits: ["hideImage", "showImage"],
  methods: {
    toggleImage(url) {
      if (url === "") {
        this.$emit("hideImage");
      } else {
        this.$emit("showImage");
      }
    }
  }
};
</script>

<template>
  <div class="article-content__header article-header justify-content-between">
    <div v-lang:da class="article-header__content">
      <span
        v-if="article.word.wordClass"
        class="article-header__element article-header__element--light article-header__element--unchained"
        >{{ article.word.wordClass }}</span
      >
      <h5
        class="article-header__word"
        :class="{ 'article-header__word--chained': article.word.wordClass }"
      >
        {{ article.word.lemma
        }}<sup v-if="article.word.hnr" class="article-header__sup">{{ article.word.hnr }}</sup>
        <small v-if="article.word.trademark" v-html="article.word.trademark" />
      </h5>
      <template v-if="article.word.alternative">
        <span
          class="article-header__element article-header__element--chained article-header__element--light"
        >
          {{ $t("article.polChildrensDada.or") }}
        </span>
        <span
          class="article-header__element article-header__element--chained article-header__element--light"
        >
          <span class="article-header__word">{{ article.word.alternative }}</span>
        </span>
      </template>
      <HeaderElement
        v-if="baseMeaning"
        :content="baseMeaning"
        wrapped
        class="article-header__element article-header__element--light"
      />
    </div>
    <div class="article-header__controls">
      <ImageButton
        v-if="article.word.illustration"
        button-class="article-header__btn"
        :illustrations="[article.word.illustration]"
        :current-active-illustration-url="activeIllustrationUrl"
        @illustration-url-update="toggleImage($event)"
      ></ImageButton>
    </div>
  </div>
</template>
